/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import Payment, { SdkMessage, MessageType, ClientSdkInstance } from '@solidgate/react-sdk'
import { createSolidGatePaymentIntent } from '@/helpers/solidGateHelpers'
import { PaymentPlan } from '@/types/types'
import { cn } from '@/lib/utils'
import {
  clickPurchaseButton,
  trackLoadedApplePay,
  trackPayment,
  trackPaymentErrors,
} from '@/helpers/facebookPixelEvents'

interface PaymentFormInterface {
  plan: PaymentPlan
  email: string
  onSuccess: (val: boolean) => void
  handleLoading: (val: boolean) => void
  version?: string
}

export const PaymentForm = (props: PaymentFormInterface) => {
  const [merchantData, setMerchantData] = useState()
  const [isFailedPayment, setIsFailedPayment] = useState(false)
  const [paymentError, setPaymentError] = useState('')
  const theme = localStorage.getItem('data-theme') ?? 'dark'
  const trafficSource = localStorage.getItem('trafficSource') ?? ''
  const mainColor = theme === 'dark' ? '#fff' : '#000'
  const borderColor = theme === 'dark' ? '#d2d2d2' : '#333a4933'
  const appleContainerRef = useRef(null)

  const handleCreatePaymentIntent = () => {
    createSolidGatePaymentIntent({
      email: props.email,
      productId: props.plan.solidGateProductID ?? '',
      failUrl: `${window.location.origin}/fail-payment`,
      trafficSource
    }).then((res) => {
      setMerchantData(res)
      trackPayment('SolidGateInit', 'true')
      setIsFailedPayment(false)
    })
  }

  useEffect(() => {
    handleCreatePaymentIntent()
  }, [props.plan])

  useEffect(() => {
    trackLoadedApplePay()
  }, [])

  useEffect(() => {
    if (!isFailedPayment) {
      handleCreatePaymentIntent()
    }
  }, [isFailedPayment])

  const handleOnError = (e: SdkMessage[MessageType.Error]) => {
    trackPaymentErrors('SolidGateError', e)
  }

  const handleOnFail = (e: SdkMessage[MessageType.Fail]) => {
    setIsFailedPayment(true)
    trackPaymentErrors('SolidGateFail', e.message)
    setPaymentError(e.message ?? '')
  }

  const handleOnMounted = (e: SdkMessage[MessageType.Mounted]) => {
    setTimeout(() => {
      props.handleLoading(false)
    }, 500)
  }

  const handleOrderStatus = (e: SdkMessage[MessageType.OrderStatus]) => {}

  const handleOnResize = (e: SdkMessage[MessageType.Resize]) => {}

  const handleOnSuccess = (e: SdkMessage[MessageType.Success]) => {
    props.onSuccess(true)
  }

  const handleOnSubmit = (e: SdkMessage[MessageType.Submit]) => {
    clickPurchaseButton('card')
  }

  const handleOnInteraction = (e: SdkMessage[MessageType.Interaction]) => {}

  const handleOnVerify = (e: SdkMessage[MessageType.Verify]) => {}

  const handleOnRedirectMessage = (e: SdkMessage[MessageType.Redirect]) => {}

  const handleOnCustomStylesAppended = (e: SdkMessage[MessageType.CustomStylesAppended]) => {}

  const handleCard = (e: SdkMessage[MessageType.Card]) => {}

  const handleOnReadyPaymentInstance = (form: ClientSdkInstance) => {}

  return props.version && props.version === 'brand' ? (
    <>
      {merchantData && (
        <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-6')}>
          <div ref={appleContainerRef} className="h-[56px]" />

          <div className="pay-with-card text-grayText relative mt-4 mb-6 flex justify-center items-center">
            <div className="line absolute top-[50%] left-0 h-[1px] w-full bg-grayText"></div>
            <span className="bg-[var(--bg)] px-2  text-[13px] relative z-[1]">OR</span>
          </div>

          <Payment
            applePayButtonParams={{
              enabled: true,
              color: theme === 'dark' ? 'white' : 'black',
              type: 'pay',
              integrationType: 'js',
            }}
            applePayContainerRef={appleContainerRef}
            merchantData={merchantData}
            styles={{
              '.two-columns': {
                gap: '8px !important',
                margin: '8px 0',
              },
              submit_button: {
                'margin-top': '16px',
                'text-transform': 'capitalize',
                background:
                  theme === 'dark'
                    ? 'linear-gradient(90deg, #FF2FDB 0%, #9829FF 25%, #293AFF 50%, #1F79FF 75%, #40E6FF 100%);'
                    : '#1D2BDB',
                color: '#FBFBFB',
                'font-weight': '700',
                'font-size': '20px',
                padding: '14px 16px',
                'border-radius': '40px',
                height: '56px',
                '.title-icon': {
                  display: 'none',
                },
                ':disabled': {
                  opacity: '0.1',
                  cursor: 'not-allowed',
                },
              },
              expiry_date: {
                'margin-right': '-7px !important',
                'margin-top': '-7.5px !important'
              },
              card_cvv: {
                'margin-left': '-7px !important',
                'margin-top': '-7.5px !important'
              },
              input_group: {
                '.label': {
                  color: theme === 'dark' ? '#6E6E70' : '#8B8B8C',
                  'font-weight': '400',
                  'font-size': '14px',
                },
                '.brand-icon': {
                  top: '46px',
                },
                input: {
                  color: theme === 'dark' ? '#FBFBFB' : '#0E0E0F',
                  background: theme === 'dark' ? '#1A1A1D' : '#FBFBFB',
                  'border-color': theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                  'font-weight': '400',
                  'font-size': '18px',
                  'border-radius': '16px',
                  height: '56px',
                  '::placeholder': {
                    color: theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                  },
                  ':focus': {
                    '::placeholder': {
                      color: theme === 'dark' ? '#6E6E70' : '#A9B2FF',
                    },
                  },
                },
                '.not-empty .label': {
                  color: mainColor,
                },
                '.not-empty.error .label': {
                  color: '#DB2A30',
                },
                '.error input': {
                  'border-color': '#DB2A30',
                },
              },
            }}
            formParams={{
              submitButtonText: 'Continue',
            }}
            onError={handleOnError}
            onFail={handleOnFail}
            onCard={handleCard}
            onMounted={handleOnMounted}
            onOrderStatus={handleOrderStatus}
            onResize={handleOnResize}
            onSuccess={handleOnSuccess}
            onSubmit={handleOnSubmit}
            onInteraction={handleOnInteraction}
            onVerify={handleOnVerify}
            onFormRedirect={handleOnRedirectMessage}
            onCustomStylesAppended={handleOnCustomStylesAppended}
            onReadyPaymentInstance={handleOnReadyPaymentInstance}
          />

          {isFailedPayment && (
            <div className="relative top-[-50px]">
              {paymentError && <p className="popup-description">{paymentError}</p>}
              <div className=" popup-wr">
                <div className="popup-inner">
                  <img
                    className="block mb-2"
                    src="/video/error.gif"
                    alt="Icon"
                    width={130}
                    height={130}
                  />
                  <h3 className="popup-title">
                    There was an error processing your payment information
                  </h3>

                  <button
                    className="text-center mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
                    onClick={() => setIsFailedPayment(false)}
                  >
                    Try again
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  ) : props.version && props.version === 'alternative' ? (
    <>
      {merchantData && (
        <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-6 alternative-payment')}>
          <div ref={appleContainerRef} className="h-[56px]" />

          <div className="pay-with-card text-[#101A361F] relative mt-11 mb-6 flex justify-center items-center">
            <div className="line absolute top-[50%] left-0 h-[1px] w-full bg-[#101A361F]"></div>
            <span className="bg-[var(--bg)] px-3 relative z-[1] text-[#101A36B2]">or pay with card</span>
          </div>

          <Payment
            applePayButtonParams={{
              enabled: true,
              color: theme === 'dark' ? 'white' : 'black',
              type: 'pay',
              integrationType: 'js',
            }}
            applePayContainerRef={appleContainerRef}
            merchantData={merchantData}
            styles={{
              '.two-columns': {
                gap: '20px !important',
                margin: '20px 0',
              },
              submit_button: {
                'margin-top': '20px',
                'background-image':
                  'linear-gradient(rgb(249, 225, 103) 0%, rgb(255, 182, 31) 100%)',
                color: '#000',
                height: '56px',
                '.title-icon': {
                  display: 'none',
                },
              },
              input_group: {
                '.label': {
                  color: '#101A36',
                  'font-weight': '600',
                  'font-size': '16px',
                },
                input: {
                  color: mainColor,
                  'border-color': borderColor,
                  height: '56px',
                  '::placeholder': {
                    color: '#101A3666',
                  },
                  ':focus': {
                    '::placeholder': {
                      color: '#d2d2d2',
                    },
                  },
                },
                '.brand-icon': {
                  top: '2.9em',
                },
                '.not-empty .label': {
                  color: mainColor,
                },
                '.not-empty.error .label': {
                  color: '#e46161',
                },
                '.error input': {
                  color: '#e46161',
                  'border-color': '#e46161',
                  '::placeholder': {
                    color: '#e46161',
                  },
                },
              },
            }}
            formParams={{
              submitButtonText: 'Continue',
            }}
            onError={handleOnError}
            onFail={handleOnFail}
            onCard={handleCard}
            onMounted={handleOnMounted}
            onOrderStatus={handleOrderStatus}
            onResize={handleOnResize}
            onSuccess={handleOnSuccess}
            onSubmit={handleOnSubmit}
            onInteraction={handleOnInteraction}
            onVerify={handleOnVerify}
            onFormRedirect={handleOnRedirectMessage}
            onCustomStylesAppended={handleOnCustomStylesAppended}
            onReadyPaymentInstance={handleOnReadyPaymentInstance}
          />

          {isFailedPayment && (
            <div className="relative top-[-50px]">
              {paymentError && <p className="popup-description">{paymentError}</p>}
              <button
                onClick={() => setIsFailedPayment(false)}
                className="text-center max-w-[300px] block mx-auto mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      )}
    </>
  ) : (
    <>
      {merchantData && (
        <div className={cn({ 'payment-response': isFailedPayment }, 'solid-gate-form mt-6')}>
          <div ref={appleContainerRef} className="h-[46px]" />

          <div className="pay-with-card text-[#d2d2d2] relative my-[15px] flex justify-center items-center">
            <div className="line absolute top-[50%] left-0 h-[1px] w-full bg-[#d2d2d2]"></div>
            <span className="bg-[var(--bg)] px-2 relative z-[1]">or pay with card</span>
          </div>

          <Payment
            applePayButtonParams={{
              enabled: true,
              color: theme === 'dark' ? 'white' : 'black',
              type: 'pay',
              integrationType: 'js',
            }}
            applePayContainerRef={appleContainerRef}
            merchantData={merchantData}
            styles={{
              submit_button: {
                'background-image':
                  'linear-gradient(rgb(249, 225, 103) 0%, rgb(255, 182, 31) 100%)',
                color: '#000',
                '.title-icon': {
                  display: 'none',
                },
              },
              input_group: {
                '.label': {
                  color: mainColor,
                },
                input: {
                  color: mainColor,
                  'border-color': borderColor,
                  '::placeholder': {
                    color: '#d2d2d2',
                  },
                  ':focus': {
                    '::placeholder': {
                      color: '#d2d2d2',
                    },
                  },
                },
                '.not-empty .label': {
                  color: mainColor,
                },
                '.not-empty.error .label': {
                  color: '#e46161',
                },
                '.error input': {
                  color: '#e46161',
                  'border-color': '#e46161',
                  '::placeholder': {
                    color: '#e46161',
                  },
                },
              },
            }}
            formParams={{
              submitButtonText: 'Continue',
            }}
            onError={handleOnError}
            onFail={handleOnFail}
            onCard={handleCard}
            onMounted={handleOnMounted}
            onOrderStatus={handleOrderStatus}
            onResize={handleOnResize}
            onSuccess={handleOnSuccess}
            onSubmit={handleOnSubmit}
            onInteraction={handleOnInteraction}
            onVerify={handleOnVerify}
            onFormRedirect={handleOnRedirectMessage}
            onCustomStylesAppended={handleOnCustomStylesAppended}
            onReadyPaymentInstance={handleOnReadyPaymentInstance}
          />

          {isFailedPayment && (
            <div className="relative top-[-50px]">
              {paymentError && <p className="popup-description">{paymentError}</p>}
              <button
                onClick={() => setIsFailedPayment(false)}
                className="text-center max-w-[300px] block mx-auto mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}
